import React from 'react';
import {Route,Switch,useRouteMatch} from 'react-router-dom';

import ProjectsList from '../Components/Administrator/ProjectsList';
import MainDashboard from '../Components/Administrator/MainDashboard';
import UsersList from '../Components/Administrator/UsersList';
import CodesetsList from '../Components/Administrator/CodesetsList';
import HistoriesList from '../Components/Administrator/HistoriesList';

import PageLoadEventEmitter from '../HoC/PageLoadEventEmitter';

export default function AdministratorRoutes(){
    let match = useRouteMatch();
    return (
        <PageLoadEventEmitter>
            <MainDashboard>
                <Switch>
                    <Route exact path={match.path+"/home"}>
                        Admin Portal
                    </Route>
                    <Route exact path={match.path+"/manageprojects"}>
                        <ProjectsList />
                    </Route>
                    <Route exact path={match.path+"/manageusers"}>
                        <UsersList />
                    </Route>
                    <Route exact path={match.path+"/viewcodesets"}>
                        <CodesetsList />
                    </Route>
                    <Route exact path={match.path+"/viewhistories"}>
                        <HistoriesList />
                    </Route>
                </Switch>
            </MainDashboard>
        </PageLoadEventEmitter>
    )
}